import "cn-next/es/icon/style";
import _Icon from "cn-next/es/icon";
import React from 'react';
export var dialogStyle = {
  minHeight: 200
};
export var getResTemplates = function getResTemplates(locale) {
  return {
    successAll: function successAll() {
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Icon, {
        size: "xl",
        style: {
          color: '#08c29e'
        },
        type: "success"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          color: '#333333'
        }
      }, locale === null || locale === void 0 ? void 0 : locale.importSuccess));
    },
    successSome: function successSome(_ref) {
      var _locale$successSomeTe, _locale$failSomeText;

      var successCount = _ref.successCount,
          errorCount = _ref.errorCount,
          url = _ref.url,
          _ref$isShowCount = _ref.isShowCount,
          isShowCount = _ref$isShowCount === void 0 ? true : _ref$isShowCount;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Icon, {
        size: "xl",
        style: {
          color: '#08c29e'
        },
        type: "success"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          color: '#333333'
        }
      }, locale === null || locale === void 0 ? void 0 : locale.importCompelate), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 4
        }
      }, isShowCount && (locale === null || locale === void 0 ? void 0 : (_locale$successSomeTe = locale.successSomeText) === null || _locale$successSomeTe === void 0 ? void 0 : _locale$successSomeTe.call(locale, successCount)), isShowCount && /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#FE3824'
        }
      }, locale === null || locale === void 0 ? void 0 : (_locale$failSomeText = locale.failSomeText) === null || _locale$failSomeText === void 0 ? void 0 : _locale$failSomeText.call(locale, errorCount)), ' ', /*#__PURE__*/React.createElement("a", {
        style: {
          color: '#0055FF'
        },
        tabignore: "true",
        href: url
      }, locale === null || locale === void 0 ? void 0 : locale.downloadRecord)));
    },
    failAll: function failAll(_ref2) {
      var errorMessage = _ref2.errorMessage,
          restart = _ref2.restart,
          errorDownloadUrl = _ref2.errorDownloadUrl,
          _ref2$isShowTryAgain = _ref2.isShowTryAgain,
          isShowTryAgain = _ref2$isShowTryAgain === void 0 ? true : _ref2$isShowTryAgain;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Icon, {
        size: "xl",
        style: {
          color: 'rgba(245,203,34,1)'
        },
        type: "warning"
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          fontSize: 16,
          color: '#333333'
        }
      }, locale === null || locale === void 0 ? void 0 : locale.importFailed), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 4,
          color: '#FE3824'
        }
      }, errorMessage), errorDownloadUrl && /*#__PURE__*/React.createElement("a", {
        style: {
          color: '#0055FF'
        },
        tabignore: "true",
        href: errorDownloadUrl
      }, locale === null || locale === void 0 ? void 0 : locale.downloadRecord), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 4
        }
      }, isShowTryAgain && /*#__PURE__*/React.createElement("a", {
        style: {
          color: '#0055FF'
        },
        href: "javascript:void(0)",
        onClick: restart
      }, locale === null || locale === void 0 ? void 0 : locale.tryAgain)));
    }
  };
};